import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { DocumentsObj } from "../../utils/types";

const initialState: DocumentsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getDocumentsData = createAsyncThunk(
  "documents",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDocumentsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getDocumentsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default documentsSlice.reducer;
